/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */
export const environment = {
  production: true,
  apiUrl: 'https://develop-nhh-harpers-cov-wave-users-services-tpaiwcfcta-uc.a.run.app/users',
  apiUrlProjectService: 'https://develop-nhh-harpers-cov-wave-projects-services-tpaiwcfcta-uc.a.run.app/projects',
  urlStorage: 'https://gamma-avwave-media.storage.googleapis.com/',
  testUser: {
    // tslint:disable-line
    token: 'cualquiercosa',
    email: 'user@user.user',
  },
};
